document.addEventListener('DOMContentLoaded', function () {

    const loadMoreBtn = document.getElementById('load-more');
    
    if( loadMoreBtn ) {
        const itemsContainer = document.getElementById('loadMore__container');
        let currentPage = 1;
        const itemsPerPage = 6; 
        const totalItems = itemsContainer.children.length;

        loadMoreBtn.addEventListener('click', function (event) {
            event.preventDefault();
            const items = Array.from(itemsContainer.children);
            const start = currentPage * itemsPerPage;
            const end = start + itemsPerPage;

            items.forEach((item, index) => {
                if (index >= start && index < end) {
                    item.classList.remove('hidden');
                }
            });

            currentPage++;

            if (end >= totalItems) {
                loadMoreBtn.style.display = 'none';
            }


        });
    }
    
});